import classNames from 'classnames';
import { FC, useMemo } from 'react';
import Crumb from './components/Crumb/Crumb';
import './style.scss';
import { CrumbsType, ICrumbProps } from './types/crumb';

const Crumbs: FC<ICrumbProps> = ({ type = CrumbsType.CRUMB, ...props }: ICrumbProps): JSX.Element => {
  const crumbsGap = useMemo((): string => {
    if (props.withPartition) return '40';
    return type === CrumbsType.CRUMB ? '20' : '15';
  }, [type, props.withPartition]);

  return (
    <ul className={classNames('crumbs', [`gap-${crumbsGap}`], props.wrapperClassName)}>
      {props.crumbs.map((crumb) => (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <Crumb key={crumb.value} type={type} crumb={crumb} {...props} />
      ))}
    </ul>
  );
};

export default Crumbs;
